import { register } from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('hero-slider-split', {
  onLoad() {
    this.settings = this.container.dataset.sectionSettings || '{}';
    this.splitSliderElement = document.querySelector(
      '#hero-slider--' + this.id
    );

    const slidesCount = Number(this.container.dataset.slides - 1);

    // Parse the settings string passed through from liquid
    this.userSettings = JSON.parse(this.settings);

    var slider = new Flickity(this.splitSliderElement, {
      freeScroll: false,
      autoplay: false,
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true,
      setGallerySize: true,
      cellAlign: 'left',
      watchCSS: true,
      wrapAround: false,
      adaptiveHeight: false,
    });

    const previousButton = this.container.querySelector('.btn--control__prev');
    previousButton.addEventListener('click', function() {
      slider.previous();
    });
    const nextButton = this.container.querySelector('.btn--control__next');
    nextButton.addEventListener('click', function() {
      slider.next();
    });

    slider.on('change', function() {
      if (slider.selectedIndex === 0) {
        previousButton.setAttribute('disabled', 'disabled');
        nextButton.removeAttribute('disabled');
      } else if (slider.selectedIndex === slidesCount) {
        nextButton.setAttribute('disabled', 'disabled');
        previousButton.removeAttribute('disabled');
      } else {
        nextButton.removeAttribute('disabled');
        previousButton.removeAttribute('disabled');
      }
    });
  },
});
